import(/* webpackMode: "eager" */ "/app/app/(app)/page.tsx");
